import { connect, useDispatch } from 'react-redux';
import { Redirect, Route } from 'react-router';
import { RootStateType } from '../redux-store/reducers';
import { AuthRoutePropsType } from './ProtectedRoute';
import { useEffect } from 'react';
import usePageTitle from '../hooks/usePageTitle';

function PageTitleSetter({ title }: { title: string }) {
  usePageTitle(title);
  return null;
}

function RedirectRoute({ component: Component, path = '', title, ...rest }: AuthRoutePropsType) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!rest.isLoggedIn) {
      // If token is not there, we are clearing the session storage data
      dispatch({ type: 'CLEAR_SESSION_DATA' });
    }
  }, [rest.isLoggedIn])

  return (
    <Route
      {...rest}
      render={(props) =>
        rest.isLoggedIn ? (
          <Redirect to="/" from={props.location.pathname} />
        ) : (
          <>
            {title && <PageTitleSetter title={title} />}
            <Component {...props} />
          </>
        )
      }
    />
  );
}

export default connect(({ auth }: RootStateType) => {
  return { isLoggedIn: !!auth.token };
}, {})(RedirectRoute);
